import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject
} from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[appHasRole]',
  standalone: true
})
export class HasRoleDirective {

  private requiredRoles: string[] = [];
  private auth = inject(AuthService);

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {

    effect(() => {

      // 👇 QUESTO crea la dependency reattiva
      const allowed = this.auth.hasAnyRole(this.requiredRoles);

      this.viewContainer.clear();

      if (allowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });

  }

  @Input()
  set appHasRole(val: string[]) {
    this.requiredRoles = val;
  }
}
